import { useState, useRef, useEffect } from "react";
import { TbLogout } from "react-icons/tb";
import { BsLayoutSidebar } from "react-icons/bs";

export default function HeaderUser({
  collapsed,
  toggleSidebar,
  userDetails = {},
  onLogout,
}) {
  const { name = "", email = "", period = "" } = userDetails;

  const [openProfile, setOpenProfile] = useState(false);
  const profileRef = useRef(null);

  const getInitials = (fullName) =>
    fullName
      ? fullName
        .split(" ")
        .map((w) => w[0])
        .join("")
        .toUpperCase()
      : "";

  useEffect(() => {
    const close = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setOpenProfile(false);
      }
    };

    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <header
      className={`fixed top-0 right-0 h-20 z-30 flex justify-between items-center
      bg-gradient-to-r from-[#673AB7] to-[#1976D2]
      border-b md:px-8 px-4 transition-all duration-300
      ${collapsed ? "md:left-20" : "md:left-64"} left-0`}
    >
      {/* LEFT */}
      <div className="flex items-center gap-3">
        {/* MOBILE TOGGLE */}
        <button
          onClick={toggleSidebar}
          className="md:hidden p-2 rounded-lg bg-white/20 text-white"
        >
          <BsLayoutSidebar className="w-5 h-5" />
        </button>

        <div>
          <h1 className="md:text-2xl text-base text-white font-medium">
            {name ? `Good ${period}, ${name}` : "Welcome"}
          </h1>
          <p className="text-sm text-white">{email}</p>
        </div>
      </div>

      {/* PROFILE */}
      <div className="relative" ref={profileRef}>
        <div
          onClick={() => setOpenProfile((p) => !p)}
          className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/20
          flex items-center justify-center text-white cursor-pointer"
        >
          {getInitials(name)}
        </div>

        {openProfile && (
          <div className="absolute right-0 mt-3 w-80 bg-white rounded-2xl shadow-lg border overflow-hidden z-50">
            {/* User Info */}
            <div className="flex items-center gap-3 px-4 py-5">
              <div className="w-12 h-12 shrink-0 rounded-full bggray textblack flex items-center justify-center font-semibold text-lg">
                {getInitials(name)}
              </div>
              <div>
                <p className="font-medium textblack">{name}</p>
                <p className="text-sm textlight">{email}</p>
              </div>
            </div>

            <div className="border-t border-gray-100" />
            <button
              onClick={() => {
                setOpenProfile(false);
                onLogout();
                console.log("Logout clicked");
              }}
              className="w-full flex items-center gap-4 px-8 py-7 transition hover:bg-gray-100"
            >
              <span className="textblack">
                <TbLogout size={26} />
              </span>
              <p className="text-lg font-medium">Logout</p>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}